import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:code",
    name: "Home",
    component: Home,
    meta: { appBarTitle: "TSVS台灣血管外科學會", backBtn: false }
  },
  {
    path: "/:code/session",
    name: "SessionList",
    component: () => import("../views/Session/List"),
    meta: { appBarTitle: "Session" }
  },
  {
    path: "/:code/session/:id",
    name: "Session",
    component: () => import("../views/Session"),
    meta: { appBarTitle: "Session" }
  },
  {
    path: "/:code/unit",
    name: "UnitList",
    component: () => import("../views/Unit/List"),
    meta: { appBarTitle: "Unit List" }
  },
  {
    path: "/:code/unit/:id",
    name: "Unit",
    component: () => import("../views/Unit"),
    meta: { appBarTitle: "Unit" }
  },
  {
    path: "/:code/person_type_select",
    name: "PersonTypeSelect",
    component: () => import("../views/Person/TypeSelect"),
    meta: { appBarTitle: "Person List" }
  },
  {
    path: "/:code/person",
    name: "PersonList",
    component: () => import("../views/Person/List"),
    meta: { appBarTitle: "Person List" }
  },
  {
    path: "/:code/person/by_position/:position",
    name: "PersonListByPosition",
    component: () => import("../views/Person/List"),
    meta: { appBarTitle: "Person List" }
  },
  {
    path: "/:code/person/:id",
    name: "Person",
    component: () => import("../views/Person"),
    meta: { appBarTitle: "Person" }
  },
  {
    path: "/:code/sponsor",
    name: "SponsorList",
    component: () => import("../views/Sponsor/List"),
    meta: { appBarTitle: "Sponsor List" }
  },
  {
    path: "/:code/sponsor/:id",
    name: "Sponsor",
    component: () => import("../views/Sponsor"),
    meta: { appBarTitle: "Sponsor" }
  },
  {
    path: "/:code/information",
    name: "Information",
    component: () => import("../views/Info"),
    meta: { appBarTitle: "Info" }
  },
  {
    path: "/:code/my_schedule",
    name: "MySchedule",
    component: () => import("../views/MySchedule"),
    meta: { appBarTitle: "My Schedule" }
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("../views/NotFound"),
    meta: { backBtn: false }
  },
  {
    path: "*",
    redirect: "NotFound"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.name === "NotFound") next();
  else {
    if (from.name == null) {
      await store.dispatch("setConference", to.params.code);
    }

    const code = store.getters.conferenceId;
    if (code == null) next({ name: "NotFound", replace: true });
    else next();
  }
});

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
